/* global localize */
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { SurveyContext } from '../context/surveyContext';
import VideoModal from '../components/VideoModal';

export default function Startpage() {
  const { setSurvey } = useContext(SurveyContext);
  const history = useHistory();
  const [videoUrl, setVideoUrl] = useState('');
  const [showModal, setShowModal] = useState(false);

  function goToSurvey(id) {
    fetch(`/wp-json/survey/v1/survey?id=${id}`)
      .then((res) => res.json())
      .then(
        (response) => {
          setSurvey(response);
          history.push(`${localize.url}/start`);
        },
        (error) => {
          console.log(error);
        }
      );
  }

  function handleOnClick() {
    setShowModal(true);
    setVideoUrl(localize.survey_youtube_link);
  }

  return (
    <div className='landingPageSurvey'>
      {showModal && (
        <VideoModal
          videoUrl={videoUrl}
          setvideoUrl={setVideoUrl}
          setShowModal={setShowModal}
        />
      )}
      <div
        className={`backgroundImage has-${localize.survey_template_bg_color}-background-color`}
        style={{
          backgroundImage: `url(${localize.survey_background_image.url})`,
        }}
      ></div>
      <div className='c-hero-area'>
        <div
          className={`c-hero-area__hero-text-wrapper has-${localize.survey_template_bg_color}-background-color`}
        >
          <div className='c-hero-area__hero-text'>
            <h1 className='entry-title'>{localize.survey_title_template}</h1>

            {localize.connected_surveys ? (
              <div className='survey-buttons__wrapper'>
                <span className='preamble-hero'>Välj om du är</span>
                <button
                  className={`surveyButton has-${localize.survey_template_bg_color}-color`}
                  onClick={() =>
                    goToSurvey(localize.connected_surveys[0].survey_id)
                  }
                >
                  {localize.connected_surveys[0].survey_button_text}
                </button>
                {localize.connected_surveys[1] ? (
                  <>
                    <span className='preamble-hero'>eller</span>
                    <button
                      className={`surveyButton has-${localize.survey_template_bg_color}-color`}
                      onClick={() =>
                        goToSurvey(localize.connected_surveys[1].survey_id)
                      }
                    >
                      {localize.connected_surveys[1].survey_button_text}
                    </button>
                  </>
                ) : (
                  ' '
                )}
              </div>
            ) : (
              ''
            )}
            {localize.survey_youtube_link ? (
              <div className='video-area'>
                <span className='divider'></span>
                <p className='subtitle_youtube'>
                  {localize.survey_subtitle_movie}
                </p>
                <p className='preamble'>{localize.survey_text_movie}</p>
                <div className='playButton' onClick={handleOnClick}>
                  <div className='play'></div>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
          <svg
            className='logo-pattern'
            xmlns='http://www.w3.org/2000/svg'
            width='645'
            height='666'
            viewBox='0 0 645 666'
          >
            <defs>
              <filter id='handelsrådet-mobil-a'>
                <feColorMatrix
                  in='SourceGraphic'
                  values='0 0 0 0 0.073349 0 0 0 0 0.073349 0 0 0 0 0.073349 0 0 0 1.000000 0'
                />
              </filter>
            </defs>
            <g fill='none' fill-rule='evenodd' transform='translate(-5 -2)'>
              <g fill='#BF6842' fill-rule='nonzero'>
                <path d='M356.304225 607.589041C341.611268 653.479452 292.940845 678.260274 247.943662 663.575342 202.028169 648.890411 177.233803 600.246575 191.926761 555.273973 206.619718 509.383562 255.290141 484.60274 300.287324 499.287671 345.284507 513.972603 370.997183 562.616438 356.304225 607.589041M613.430986 414.849315C652 442.383562 661.183099 496.534247 633.633803 535.082192 606.084507 573.630137 551.904225 582.808219 513.335211 555.273973 474.766197 527.739726 465.583099 473.589041 493.132394 435.041096 520.68169 395.575342 574.861972 387.315068 613.430986 414.849315M509.661972 110.136986C548.230986 81.6849315 602.411268 89.9452055 630.878873 128.493151 659.346479 167.041096 651.08169 221.191781 612.512676 249.643836 573.943662 278.09589 519.76338 269.835616 491.295775 231.287671 462.828169 192.739726 471.092958 138.589041 509.661972 110.136986M187.335211 115.643836C171.723944 70.6712329 196.51831 21.109589 241.515493 6.42465753 286.512676-8.26027397 336.101408 15.6027397 350.794366 60.5753425 366.405634 105.547945 341.611268 155.109589 296.614085 169.794521 251.616901 185.39726 202.946479 160.616438 187.335211 115.643836M92.7492958 423.109589C44.9971831 423.109589 5.50985915 385.479452 5.50985915 337.753425 5.50985915 290.027397 43.1605634 250.561644 90.9126761 250.561644 138.664789 250.561644 178.152113 288.191781 178.152113 335.917808 179.070423 383.643836 140.501408 422.191781 92.7492958 423.109589' />
                <path d='M641.898592,295.534247 C636.388732,294.616438 630.878873,293.69863 624.450704,292.780822 C599.656338,306.547945 572.107042,312.054795 545.476056,308.383562 C437.115493,295.534247 393.03662,161.534247 472.011268,86.2739726 L473.847887,68.8356164 C452.726761,59.6575342 429.769014,51.3972603 405.892958,47.7260274 C403.138028,53.2328767 400.383099,57.8219178 397.628169,63.3287671 C403.138028,90.8630137 399.464789,119.315068 388.44507,143.178082 C342.529577,241.383562 201.109859,243.219178 154.276056,144.09589 C148.766197,142.260274 143.256338,139.506849 138.664789,136.753425 C123.053521,154.191781 108.360563,173.465753 97.3408451,194.575342 L109.278873,207.424658 C217.639437,220.273973 262.63662,354.273973 184.580282,429.534247 C165.295775,447.890411 139.583099,460.739726 112.033803,464.410959 C108.360563,469 104.687324,472.671233 100.095775,477.260274 C112.033803,498.369863 125.808451,517.643836 142.338028,535.082192 L157.949296,527.739726 C203.864789,427.69863 346.202817,428.616438 392.11831,524.986301 C404.056338,548.849315 408.647887,577.30137 403.138028,604.835616 C405.892958,609.424658 408.647887,614.931507 411.402817,620.438356 C435.278873,615.849315 457.31831,607.589041 479.357746,597.493151 L476.602817,580.054795 C452.726761,558.027397 438.952113,528.657534 435.278873,498.369863 C423.340845,395.575342 533.538028,321.232877 625.369014,370.794521 C630.878873,369.876712 636.388732,368.041096 642.816901,368.041096 C644.653521,343.260274 644.653521,319.39726 641.898592,295.534247 M438.033803,346.931507 C430.687324,394.657534 386.608451,426.780822 338.856338,420.356164 C291.104225,413.013699 258.96338,368.958904 265.391549,321.232877 C272.738028,273.506849 316.816901,241.383562 364.569014,247.808219 C412.321127,255.150685 445.380282,300.123288 438.033803,346.931507' />
              </g>
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
}
